import { render, staticRenderFns } from "./SummerCampWhyChoose.vue?vue&type=template&id=63870a03&scoped=true&"
import script from "./SummerCampWhyChoose.vue?vue&type=script&lang=js&"
export * from "./SummerCampWhyChoose.vue?vue&type=script&lang=js&"
import style0 from "./SummerCampWhyChoose.vue?vue&type=style&index=0&id=63870a03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63870a03",
  null
  
)

export default component.exports